import i18n from '@/plugins/i18n';

const amqOverviewGraphs = () => ({
  memory: {
    lineCharts: [
      {
        width: '49%',
        title: i18n.global.t('mq.heap-memory'),
        header: {
          title: i18n.global.t('mq.heap-memory'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#F7507F'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'artemis_broker_jvm_memory_heap',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('mq.memoryInMB'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('mq.memoryInMB'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
      {
        width: '49%',
        title: i18n.global.t('mq.non-heap-memory'),
        header: {
          title: i18n.global.t('mq.non-heap-memory'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FDFCAC'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'artemis_broker_jvm_memory_non_heap',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('mq.memoryInMB'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('mq.memoryInMB'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
      {
        width: '49%',
        title: i18n.global.t('mq.memory-usages'),
        header: {
          title: i18n.global.t('mq.memory-usages'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#2BEECA'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'artemis_broker_current_memory_usage_bytes',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('mq.memoryInMB'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('mq.memoryInMB'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
    ],
  },
  queue: {
    lineCharts: [
      {
        width: '49%',
        title: i18n.global.t('mq.no-of-queues'),
        header: {
          title: i18n.global.t('mq.no-of-queues'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#F7507F'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'artemis_broker_queue_count',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        width: '49%',
        title: i18n.global.t('mq.threadCount'),
        header: {
          title: i18n.global.t('mq.threadCount'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FDFCAC'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'artemis_broker_thread_count',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        width: '49%',
        title: i18n.global.t('mq.transport-acceptors'),
        header: {
          title: i18n.global.t('mq.transport-acceptors'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FDFCAC'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'artemis_broker_acceptor_count',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
    ],
  },
});

export default amqOverviewGraphs;
